import DountChart from '@/components/charts/dount-chart/dount-chart';
import { learningRegistryAPI } from '@/providers/apis/learning-registry/learning-registry';
import { Vue, Component } from 'vue-property-decorator';
import axios from 'axios';
import TooldataPullupComponent from '@/components/data-lake/tool-data-pullup/tool-data-pullup';
import { dataLakeAPI } from '@/providers/apis/data-lake/data-lake';
import { DataInStatsModel, OverallStatsModel } from '@/models/data-lake/data-lake';
import moment from 'moment';

@Component({
    name: 'datalake-dashboard',
    components: {
        'dount-chart': DountChart,
        'provider-pullup': TooldataPullupComponent,
    },
})

export default class DatalakeDashboard extends Vue {

    // ----------------------------------------------------------------------------------
    // Properties

    private productFields = [
        {
            label: 'S.No',
            key: 'index',
        },
        {
            label: 'Name',
            key: 'toolName',
            sortable: true,
            tdClass: 'text-capitalize text-truncate',
        },
        {
            label: 'Subject',
            key: 'subjects',
            tdClass: ['text-capitalize'],
        },
        {
            label: 'Grade',
            key: 'grades',
            tdClass: ['text-capitalize'],
        },
        {
            label: 'Vol',
            key: 'volume',
        },
    ];

    private productList: any = [];

    private dountChartData: any = [];

    private rangeFilter: any = [
        {
            name: 'Today',
            key: 'today',
            startDate: moment().format('YYYY-MM-DD'),
            endDate: moment().format('YYYY-MM-DD'),
        },
        {
            name: 'Current Week',
            key: 'week',
            startDate: moment().startOf('week').format('YYYY-MM-DD'),
            endDate: moment().format('YYYY-MM-DD'),
        },
        {
            name: 'Previous Week',
            key: 'last-week',
            startDate: moment().subtract(1, 'week').startOf('week').format('YYYY-MM-DD'),
            endDate: moment().subtract(1, 'week').endOf('week').format('YYYY-MM-DD'),
        },
        {
            name: 'Current Month',
            key: 'month',
            startDate: moment().startOf('month').format('YYYY-MM-DD'),
            endDate: moment().format('YYYY-MM-DD'),
        },
        {
            name: 'Till Now',
            key: 'till-now',
        },
    ];

    private activeRange = this.rangeFilter[4];

    private providersList: any = [];

    private overallStats: OverallStatsModel = {} as OverallStatsModel;

    private datalakeDataIn: DataInStatsModel[] = [];

    private topProviders: DataInStatsModel[] = [];

    private isLoading: boolean = false;

    private selectedTool: DataInStatsModel = {} as DataInStatsModel;

    // ----------------------------------------------------------------------------------
    // Hooks

    private created() {
        // this.fetchProvidersList();
        this.fetchDataLakeList();
        this.fetchTopProviders();
    }


    // ----------------------------------------------------------------------------------
    // Actions

    private onChangeRange(range: any) {
        this.activeRange = range;
        this.fetchTopProviders();
    }

    private onShowPullup(selectedTool: DataInStatsModel) {
        this.selectedTool = selectedTool;
        this.$bvModal.show('data-lake-pullup');
    }

    // ----------------------------------------------------------------------------------
    // Methods

    // private fetchProvidersList() {
    //     axios.all([
    //         learningRegistryAPI.fetchToolRegistryList({}),
    //         learningRegistryAPI.fetchContentProviderList({}) as any,
    //     ]).then(axios.spread((toolRegistry, contentRegistry) => {
    //         this.providersList = [...toolRegistry.providers, ...contentRegistry.contentRegistry];
    //         this.dountChartData = this.parseProviderVol();
    //         this.parseTop5Provider();
    //     }));

    // }

    // private parseProviderVol() {
    //     const contentsTool: any = [];
    //     const providersList = JSON.parse(JSON.stringify(this.providersList));
    //     providersList.forEach((provider: any) => {
    //         const toolObj = {
    //             name: provider.name,
    //             value: Math.round(Math.random() * 20),
    //         };
    //         contentsTool.push(toolObj);
    //     });
    //     return contentsTool;
    // }

    // private parseTop5Provider() {
    //     const providersList = JSON.parse(JSON.stringify(this.providersList));
    //     const topProviders = [];
    //     let count = 0;
    //     for (const provider of providersList) {
    //         count++;
    //         const providerObj = {
    //             name: provider.name,
    //             subject: provider.subjectData ? provider.subjectData.title : 'All',
    //             grade: provider.grades && provider.grades.length
    //                     ? (provider.grades.map((grade: any) => grade.grade))[0]
    //                     : 'All',
    //             vol: `${Math.round(Math.random() * 30)} MB`,
    //         };
    //         topProviders.push(providerObj);
    //         this.productList = topProviders;
    //         if (count > 4) {
    //             break;
    //         }
    //     }
    // }

    private fetchDataLakeList() {
        dataLakeAPI.fetchDataLake({}).then((dataDakeList) => {
            const {overallStats, datalakeDataInStats} = dataDakeList;
            this.overallStats = overallStats;
            this.datalakeDataIn = datalakeDataInStats;
            datalakeDataInStats.forEach((item) => {
                this.dountChartData.push({
                    value: item.volume,
                    name: item.toolName,
                });
            });
        });
    }

    private fetchTopProviders() {
        this.isLoading = true;
        const activeRange = this.activeRange;
        const hasFilter = activeRange.key !== 'till-now';
        let params = {};
        if (hasFilter) {
            const endDate = activeRange.endDate;
            const startDate = activeRange.startDate;
            params = {
                startDate,
                endDate,
            };
        }
        dataLakeAPI.fetchDataLake(params).then((dataDakeList) => {
            const {datalakeDataInStats} = dataDakeList;
            this.topProviders = datalakeDataInStats.slice(0, 5);
            this.isLoading = false;
        });
    }
}
